/* istanbul ignore file */
import React from 'react';
import { Button } from '@mui/material';

interface ModificationTokenButtonProps {
  isActive: boolean;
  onClick: () => void;
  label: string;
}

const ModificationTokenButton = ({ isActive, onClick, label }: ModificationTokenButtonProps) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        flex: 1,
        padding: '10px',
        marginBottom: '10px',
        borderRadius: 0,
        borderRight: '1px solid',
        borderBottom: isActive ? 'none' : '1px solid',
        borderColor: 'border.medium',
        backgroundColor: 'background.paper',
        color: 'text.primary',
        '&:last-child': {
          borderRight: 'none',
        },
        '&:hover': {
          backgroundColor: 'border.medium',
        },
      }}
    >
      {label}
    </Button>
  );
};

export default ModificationTokenButton;
